<h3 class="subtitulo">Prazo de atendimento</h3>
<div [formGroup]="form" class="form-group">
  <mat-radio-group [color]="'primary'" formControlName="nroSla">
    <mat-radio-button value="120" [attr.data-cy]="'radio-sla-5'">5 dias</mat-radio-button>
    <mat-radio-button value="72" [attr.data-cy]="'radio-sla-3'">3 dias</mat-radio-button>
    <mat-radio-button value="48" [attr.data-cy]="'radio-sla-2'">2 dias</mat-radio-button>
    <mat-radio-button value="24" [attr.data-cy]="'radio-sla-1'">1 dia</mat-radio-button>
  </mat-radio-group>
</div>
